const formatRoles = (roles) => {
  return roles.map((role) => (typeof role === 'object' && role.name ? role.name : role));
};

const isAccessPermitted = ({ roles, excludeRoles, userRole, emailVerified }) => {
  if (((!roles || !roles.length) && !userRole) || !emailVerified) {
    return false;
  }

  const ROLES = roles && formatRoles(roles);
  const EXCLUDE_ROLES = excludeRoles && formatRoles(excludeRoles);

  if (ROLES) {
    return Array.isArray(ROLES) ? ROLES.lastIndexOf(userRole) !== -1 : ROLES === userRole;
  } else if (EXCLUDE_ROLES) {
    return Array.isArray(EXCLUDE_ROLES)
      ? EXCLUDE_ROLES.indexOf(userRole) === -1
      : EXCLUDE_ROLES !== userRole;
  }

  if (!ROLES && !EXCLUDE_ROLES) {
    return true;
  }

  return false;
};

export default isAccessPermitted;
